import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { AUTH_FRAME_CLOSED } from '@chegg-wt/core/components/AuthIframe/authLogic'
import { useSelector, useDispatch } from 'react-redux'
import {
  SuperAuthIFrameModalData,
  SuperAuthIframeOrigin,
} from '@chegg-wt/core/components/Modals/SuperAuthIFrameModal/types'
import { formSubmitStopped } from '@chegg-wt/core/state/form/actions'
import { useEffect } from 'react'
import { NextJsRoute } from '../types/core'
import { navigated } from '../state/app/actions'
import { currentStyleSelector } from '../state/currentProject/selectors'
import { modalDataSelector } from '../state/modals/selectors'

interface OneAuthEventsHandlerArgs {
  closeModal: (origin?: string) => void
}

export const useOneAuthLoginRedirect = () => {
  const { toSourceTypeSelection, toPlagiarism } = useRoutesContext()
  const currentStyle = useSelector(currentStyleSelector)
  const data = useSelector(modalDataSelector) as SuperAuthIFrameModalData
  switch (data.origin) {
    case SuperAuthIframeOrigin.CREATE_CITATION_HOMEPAGE:
      return toSourceTypeSelection({ style: currentStyle }) as NextJsRoute
    case SuperAuthIframeOrigin.CHECK_PAPER_HOMEPAGE:
      return toPlagiarism() as NextJsRoute
    default:
  }
}
// change in this file
const useOneAuthEventsHandler = ({ closeModal }: OneAuthEventsHandlerArgs) => {
  const redirectTo = useOneAuthLoginRedirect()
  const data = useSelector(modalDataSelector) as SuperAuthIFrameModalData
  const dispatch = useDispatch()

  const redirectOnClose = () => {
    if (
      !data.hardGate &&
      (data.origin === SuperAuthIframeOrigin.CREATE_CITATION_HOMEPAGE ||
        data.origin === SuperAuthIframeOrigin.CHECK_PAPER_HOMEPAGE)
    ) {
      dispatch(navigated(redirectTo))
    }
  }

  /**
   * 1:- Handling Superauth frame closed event
   * 2:- Handling Superauth login/account creation success event
   */
  const messageHandler = ({ type }) => {
    if (type === AUTH_FRAME_CLOSED) {
      if (
        data.origin === SuperAuthIframeOrigin.REDESIGNED_UNLOCK_MODAL ||
        data.origin === SuperAuthIframeOrigin.CITATION_FORM_PAGE
      ) {
        dispatch(formSubmitStopped())
      }

      closeModal(data.origin)
      redirectOnClose()
    }
  }

  window.addEventListener('message', messageHandler, false)

  useEffect(() => {
    const onKeyUp = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        dispatch(formSubmitStopped())
        closeModal(data.origin)
        redirectOnClose()
      }
    }

    window.addEventListener('keyup', onKeyUp)
    return () => window.removeEventListener('keyup', onKeyUp)
  })
}

export default useOneAuthEventsHandler
